import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Giriş başarılı");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7FAFC] px-5">
      <div className="w-full max-w-md rounded-3xl border border-gray-100 bg-white p-8 sm:p-10 shadow-[0_40px_80px_-50px_rgba(11,59,117,0.4)]">
        <div className="flex justify-center"><Logo /></div>
        <div className="mt-8 flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-[#1677FF]">
          <Lock size={14} /> Yönetici Girişi
        </div>
        <h1 className="mt-2 font-heading text-2xl font-bold text-[#172033]">Partner Başvuruları</h1>
        <form onSubmit={submit} className="mt-7 space-y-5">
          <div>
            <Label className="mb-2 block text-sm font-semibold text-[#172033]">E-posta</Label>
            <Input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" required />
          </div>
          <div>
            <Label className="mb-2 block text-sm font-semibold text-[#172033]">Şifre</Label>
            <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" required />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#1677FF] px-6 py-3.5 text-base font-semibold text-white hover:bg-[#0B3B75] transition-colors disabled:opacity-70"
          >
            {loading ? <><Loader2 size={18} className="animate-spin" /> Giriş yapılıyor...</> : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}
